import { loadModuleDirectly } from '../../../../@Util/DependencyInjection/Injection/DependencyInjection';
import { CurrentUserStore } from '../../User/CurrentUserStore';

export default function isNonEssentialEdition(): boolean
{
    return loadModuleDirectly(CurrentUserStore).isNonEssentialEdition;
}
